// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberCard__member-card-container-ef4f7e {
  overflow: hidden;
  position: relative;
  display: flex;
  padding: 8px;
}

.MemberCard__member-card-container-ef4f7e:hover .MemberCard__action-a54717 {
  display: flex;
}

.MemberCard__member-card-container-ef4f7e:hover .MemberCard__hand-raised-container-f6797c:not(:last-child) {
  display: none;
}

.MemberCard__avatar-container-dd2738 {
  position: relative;
  flex: 0 0 auto;
}

.MemberCard__muted-badge-b80195 {
  position: absolute;
  right: -8px;
  bottom: 0;
  background-color: var(--addition-50);
}

.MemberCard__muted-badge-b80195 svg {
  fill: var(--addition-80) !important;
}

.MemberCard__content-bd523b {
  display: flex;
  flex: 1 1 auto;
  margin-inline-end: 8px;
  flex-direction: column;
  margin-inline-start: 16px;
  overflow: hidden;
}

.MemberCard__title-dcd41f {
  display: flex;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--addition-50);
}

.MemberCard__title-name-b4c649 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MemberCard__subtitle-e0d272 {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.MemberCard__subtitle-e0d272.MemberCard__on-call-a9fc00 {
  color: var(--addition-90);
}

.MemberCard__subtitle-e0d272.MemberCard__declined-c29454,
.MemberCard__subtitle-e0d272.MemberCard__left-dcb86a,
.MemberCard__subtitle-e0d272.MemberCard__not-on-call-d98906 {
  color: var(--addition-50);
}

.MemberCard__actions-fe8beb {
  display: flex;
  min-width: 40px;
  flex: 0 0 auto;
  align-items: center;
  margin-inline-end: 8px;
}

.MemberCard__action-a54717 {
  display: none;
  align-items: center;
  margin-inline-end: 24px;
}

.MemberCard__action-a54717:last-child {
  margin-inline-end: 0;
}

.MemberCard__hand-raised-f0a5f8 {
  fill: var(--color-icon-default);
  flex: 0 0 auto;
}

.MemberCard__hand-raised-with-number-bfba40 {
  margin-inline-end: 4px;
}

.MemberCard__hand-raised-container-f6797c {
  height: 26px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--addition-130);
}

.MemberCard__hand-raised-container-with-number-d48cfb {
  border-radius: 16px;
}

.MemberCard__hand-raised-number-a47044 {
  font: var(--font-subtitle-2);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/MemberList/MemberCard/MemberCard.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;;;EAGE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAGA;EACE,+BAAA;EACA,cAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF","sourcesContent":[".member-card-container {\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  padding: 8px;\n}\n\n.member-card-container:hover .action {\n  display: flex;\n}\n\n.member-card-container:hover .hand-raised-container:not(:last-child) {\n  display: none;\n}\n\n.avatar-container {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.muted-badge {\n  position: absolute;\n  right: -8px;\n  bottom: 0;\n  background-color: var(--addition-50);\n}\n\n.muted-badge svg {\n  fill: var(--addition-80) !important;\n}\n\n.content {\n  display: flex;\n  flex: 1 1 auto;\n  margin-inline-end: 8px;\n  flex-direction: column;\n  margin-inline-start: 16px;\n  overflow: hidden;\n}\n\n.title {\n  display: flex;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--addition-50);\n}\n\n.title-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtitle {\n  display: flex;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  align-items: center;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.subtitle.on-call {\n  color: var(--addition-90);\n}\n\n.subtitle.declined,\n.subtitle.left,\n.subtitle.not-on-call {\n  color: var(--addition-50);\n}\n\n.actions {\n  display: flex;\n  min-width: 40px;\n  flex: 0 0 auto;\n  align-items: center;\n  margin-inline-end: 8px;\n}\n\n.action {\n  display: none;\n  align-items: center;\n  margin-inline-end: 24px;\n}\n\n.action:last-child {\n  margin-inline-end: 0;\n}\n\n\n.hand-raised {\n  fill: var(--color-icon-default);\n  flex: 0 0 auto;\n}\n\n.hand-raised-with-number {\n  margin-inline-end: 4px;\n}\n\n.hand-raised-container {\n  height: 26px;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: var(--addition-130);\n}\n\n.hand-raised-container-with-number {\n  border-radius: 16px;\n}\n\n.hand-raised-number {\n  font: var(--font-subtitle-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"member-card-container": `MemberCard__member-card-container-ef4f7e`,
	"memberCardContainer": `MemberCard__member-card-container-ef4f7e`,
	"action": `MemberCard__action-a54717`,
	"hand-raised-container": `MemberCard__hand-raised-container-f6797c`,
	"handRaisedContainer": `MemberCard__hand-raised-container-f6797c`,
	"avatar-container": `MemberCard__avatar-container-dd2738`,
	"avatarContainer": `MemberCard__avatar-container-dd2738`,
	"muted-badge": `MemberCard__muted-badge-b80195`,
	"mutedBadge": `MemberCard__muted-badge-b80195`,
	"content": `MemberCard__content-bd523b`,
	"title": `MemberCard__title-dcd41f`,
	"title-name": `MemberCard__title-name-b4c649`,
	"titleName": `MemberCard__title-name-b4c649`,
	"subtitle": `MemberCard__subtitle-e0d272`,
	"on-call": `MemberCard__on-call-a9fc00`,
	"onCall": `MemberCard__on-call-a9fc00`,
	"declined": `MemberCard__declined-c29454`,
	"left": `MemberCard__left-dcb86a`,
	"not-on-call": `MemberCard__not-on-call-d98906`,
	"notOnCall": `MemberCard__not-on-call-d98906`,
	"actions": `MemberCard__actions-fe8beb`,
	"hand-raised": `MemberCard__hand-raised-f0a5f8`,
	"handRaised": `MemberCard__hand-raised-f0a5f8`,
	"hand-raised-with-number": `MemberCard__hand-raised-with-number-bfba40`,
	"handRaisedWithNumber": `MemberCard__hand-raised-with-number-bfba40`,
	"hand-raised-container-with-number": `MemberCard__hand-raised-container-with-number-d48cfb`,
	"handRaisedContainerWithNumber": `MemberCard__hand-raised-container-with-number-d48cfb`,
	"hand-raised-number": `MemberCard__hand-raised-number-a47044`,
	"handRaisedNumber": `MemberCard__hand-raised-number-a47044`
};
module.exports = ___CSS_LOADER_EXPORT___;
